/**
 * @fileoverview トラブルシューティングページのトップコンテンツを記述したファイルです。
 */

import Accordion from "../components/Accordion.tsx";
import { Link } from "react-router-dom";

/**
 * 質問と回答のリスト
 */
const AccordionItems = [
  {
    title: "Q. PCが本体を認識しない。",
    content: (
      <div>
        <p className="c-text">
          A.
          以下の原因が考えられます。それぞれの原因に合わせた処置を行ってください。
        </p>
        <ul className="c-square" style={{ textIndent: "0em" }}>
          <li>
            デバイスドライバーをインストールしていない。
            <br />
            <Link to="/gas-log-reader/HowToInstallDeviceDriver">
              デバイスドライバーのインストール方法
            </Link>
            を参照して、デバイスドライバーをインストールしてください。
          </li>
          <li>
            USBケーブルの接続不良。
            <br />
            再度接続をやり直してください。USBハブやUSB延長ケーブルを使用している場合、
            USBケーブルは接続機器のUSBコネクターに直接接続してください。
          </li>
          <li>
            USBケーブルの劣化。
            <br />
            USBケーブルの交換を最寄りの弊社営業所または販売店に依頼してください。
          </li>
        </ul>
      </div>
    ),
  },
];

/**
 * エラーとその対処方法のリスト
 */
const ErrorItems = [
  {
    title: "エラー: 読み取り機をUSBポートに接続してください。",
    content: (
      <div>
        対処: 本体がPCに接続されていません。本体をPCに接続してください。
      </div>
    ),
  },
  {
    title:
      "エラー: 読み取り機通信エラー 読み取り機を接続しなおしてから、再度ポートを選択してください。",
    content: (
      <div>
        対処:
        選択したポートが間違っている、または他のソフトで使われているか、本体が正常に接続されていません。
        本体を接続しなおしてから、もう一度ポートを選択してください。
      </div>
    ),
  },
  {
    title:
      "エラー: 有効な機器が見つかりませんでした。接続する機器をロギングデータ読み出しモードにした後、スキャン開始を押してください。",
    content: (
      <div>
        対処: ロギング読み出しモードになっているGOC-200が見つかりませんでした。
        GOC-200をロギングモードにしてから再度スキャン開始ボタンを押してください。
      </div>
    ),
  },
  {
    title:
      "エラー: スキャン失敗 再度スキャンを開始するか、読み取り機を接続しなおしてください。",
    content: (
      <div>
        対処:
        スキャンを開始しましたが失敗しました。再度スキャン開始ボタンを押してください。
      </div>
    ),
  },
  {
    title:
      "エラー: 選択した機器と接続できませんでした。 選択した機器がロギングデータ読み出しモードになっていることを確認して、再度読み取りをスタートしてください。",
    content: (
      <div>
        対処: 選択した機器に接続を試みましたが、接続できませんでした。
        GOC-200をロギング読み出しモードにしてから再度スタートボタンを押してください。
      </div>
    ),
  },
  {
    title:
      "エラー: ログ情報が正しく読み取れませんでした。 再度読み取りをスタートしてください。",
    content: (
      <div>
        対処: ロギングデータの情報部分が正しい形式で送られてきませんでした。
        スタートボタンを押して再度読み取りをしてください。
      </div>
    ),
  },
  {
    title:
      "エラー: データ数が一致しませんでした。 再度読み取りをスタートしてください。",
    content: (
      <div>
        対処:
        ロギングデータの情報に記録されているデータ数と、実際のロギングデータのデータ数が一致しませんでした。
        スタートボタンを押して再度読み取りをしてください。
      </div>
    ),
  },
  {
    title: "エラー: 読み取りましたが、データはありませんでした。",
    content: (
      <div>
        対処: ロギングデータが1つも記録されていませんでした。
        ロギングデータが記録されているGOC-200でロギングデータの読み取りをしてください
      </div>
    ),
  },
  {
    title:
      "エラー: ロギングデータの受診に失敗しました。 選択した機器がロギングデータ読み出しモードになっていることを確認して、再度読み取りをスタートしてください。",
    content: (
      <div>
        対処:
        ロギングデータの受信中にGOC-200が遠くに離れる、電源が切れる、Wi-Fi、電子レンジによる電波障害などの原因で、通信できなくなりました。
        GOC-200がロギングデータ読み取りモードであることを確認し、本体の上においてから、再度スタートボタンを押してください。
      </div>
    ),
  },
  {
    title:
      "エラー: 受信が中断されました。再度読み取りを行う場合はスタートを押してください。",
    content: (
      <div>
        対処: ロギングデータの受信中にGOC-200で送信が中断されました。
        再度読み取りを行う場合はスタートボタンを押してください。
      </div>
    ),
  },
  {
    title:
      "エラー: 読み取り機が切断されました。再度接続してポートを選択してください。",
    content: (
      <div>
        対処: 本体がPCから切断されました。
        再度本体をPCに接続し、ポートを選択してください。
      </div>
    ),
  },
];

/**
 * Help and support page
 * @returns {JSX.Element} トラブルシューティングページの JSX element
 */
export function HelpAndSupport(): JSX.Element {
  return (
    <>
      <section className="c-section">
        <h2 className="p-heading-2">トラブルシューティング</h2>
        {/* アコーディオンインターフェイス ここから */}
        <Accordion items={AccordionItems} />
        {/* アコーディオンインターフェイス ここまで */}
      </section>
      <section className="c-section">
        <h2 className="p-heading-2">GasLogReaderエラーメッセージ</h2>
        <p className="c-text">
          GasLogReaderのエラーメッセージは画面上部に赤色で表示されます。
        </p>
        {/* アコーディオンインターフェイス ここから */}
        <Accordion items={ErrorItems} />
        {/* アコーディオンインターフェイス ここまで */}
      </section>
    </>
  );
}
